import { defineCustomElement } from '@tyler-components-web/core';
import { BadgeComponent } from './badge';
export * from './badge-adapter';
export * from './badge-constants';
export * from './badge-foundation';
export * from './badge';
export function defineBadgeComponent() {
    defineCustomElement(BadgeComponent);
}
